export default {
    InlineTranslationMessageTranslated: {
        datapoint: {
            name: 'InlineTranslationMessageTranslated',
            cosmosOnlyData: (itemId: string) => itemId,
        },
    },

    InlineTranslationMessageUntranslated: {
        datapoint: {
            name: 'InlineTranslationMessageUntranslated',
            cosmosOnlyData: (itemId: string) => itemId,
        },
    },
};
